import { classnames } from 'Utils/classnames';
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

const ToogleSeoText = ({ title, text, gutterBottom, rootExtraClass = '', extraClass = '', gutterVertical }) => {
  const [visibleAll, setVisibleAll] = useState(false);
  const [isSingleLine, setIsSingleLine] = useState(false);
  const contentRef = useRef(null);
  
  useEffect(() => {
    if (contentRef.current) {
      const height = contentRef.current.clientHeight;
      const lineHeight = parseInt(window.getComputedStyle(contentRef.current).lineHeight) || 20;
      setIsSingleLine(height <= lineHeight * 1.5); // Tek satır veya biraz fazlası
    }
  }, [text]);
  
  const handleClick = e => {
    setVisibleAll(!visibleAll);
  };
  
  const toggleLink = !isSingleLine && <a title={ visibleAll ? 'Metni Küçült' : 'Devamını gör' } role="button"
    className='events-container__seo--togglelink' onClick={ handleClick }>{ visibleAll ? 'Metni Küçült' : 'Devamını gör' }</a>;
  
  const rootClasses = classnames({
    'events-container__seo': true,
    'events-container__seo--block': visibleAll,
    'events-container__seo--gutter-bottom': gutterBottom,
    'events-container__seo--gutter-vertical': gutterVertical,
    [rootExtraClass]: rootExtraClass,
  });

  const contentClasses = classnames({
    'events-container__seo--content': !visibleAll,
    [extraClass]: true,
  });
  
  return (
    <div className={ rootClasses } >
      <Helmet>
        { title && <title>{ title }</title> }
        { text && <meta name="description" content={ text } /> }
      </Helmet>
      <div
        ref={ contentRef }
        className={ contentClasses }
        dangerouslySetInnerHTML={ { __html: text } }
      />
      { toggleLink }
    </div>
  );
};
export default ToogleSeoText;

ToogleSeoText.propTypes = {
  text: PropTypes.string,
  title: PropTypes.string,
  gutterBottom: PropTypes.bool,
  gutterVertical: PropTypes.bool,
  rootExtraClass: PropTypes.string,
  extraClass: PropTypes.string
};
